
import styles from "./TestForm.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react';

import icon_delete from 'assets/icons/delete.png'
import Notification from "utils/Notifications";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { PatchPartWorkTestAnswer } from "service/TestService";


const TestChangeForm = ({ item, setRender, ChangeRowOn }) => {
  const { t } = useTranslation('common')

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    const selected = item.type_answer

    const [id, setId] = useState(null);
    const handleSelection = (id) => {
        setRows([
            { id: 1, textValue: "", score: 0, min: "", max: "", isChecked: false, file: null },
        ]);
        setNumberField('');
        setSelectField('100');
        setPointsWrong('');
        setPointsCorrect('');

        if (id === 'sequenceOrdering') {
            setCheckpoints(false)
        }

    };


    const [text, setText] = useState('');

    const handleChange = (event) => {
        setText(event.target.value);
    };


    const [rows, setRows] = useState([
        { id: 1, editorState: EditorState.createEmpty(), score: 0, ranswer: 0, file: null, textValue: "", min: "", max: "" },
    ]);


    const addRow = () => {
        const newRow = {
            id: rows.length + 1,
            editorState: EditorState.createEmpty(),
            score: 0,
        };
        setRows([...rows, newRow]);
    };

    const removeRow = (id) => {
        const updatedRows = rows
            .filter((row) => row.id !== id)
            .map((row, index) => ({
                ...row,
                id: index + 1, 
            }));
        setRows(updatedRows);
    };
    const moveRow = (index, direction) => {
        const newRows = [...rows];

        if (direction === "up" && index > 0) {
            const temp = newRows[index];
            newRows[index] = newRows[index - 1];
            newRows[index - 1] = temp;
        }
        else if (direction === "down" && index < rows.length - 1) {
            const temp = newRows[index];
            newRows[index] = newRows[index + 1];
            newRows[index + 1] = temp;
        }

        const updatedRows = newRows.map((row, i) => ({
            ...row,
            id: i + 1, 
        }));

        setRows(updatedRows);
    };

    const [file, setFile] = useState(null);

    const handleFileChange_test = (e) => {
        setFile(e.target.files[0]);
    };
    const [editorStateComment, setEditorStateCom] = useState(EditorState.createEmpty());
     
    const onEditorStateChangeComment = (newState) => {
        setEditorStateCom(newState);
    };
    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    const onEditorStateChange = (newState) => {
        setEditorState(newState);
    };
    const DraftContent = (draftData) => {
        try {

            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            const contentState = convertFromRaw(parsedData);

            const newEditorState = EditorState.createWithContent(contentState);
            setEditorState(newEditorState);


        } catch (error) {
        }
    };

    const DraftContentComment = (draftData) => {
        try {

            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            const contentState = convertFromRaw(parsedData);

            const newEditorState = EditorState.createWithContent(contentState);
            setEditorStateCom(newEditorState);


        } catch (error) {
        }
    };
    
    useEffect(() => {

        if (item?.id) {
            DraftContent(item.body)
            DraftContentComment(item.comment)
            setSelectField(item.max_len)
            setPointsWrong(item.points_for_the_wrong_answer)
            setPointsCorrect(item.points_for_the_correct_answer)
            setNumberField(item.max_points_for_the_correct_answer)
            removeRow(1)
            for (let i = 0; i < item.answer_part_worktest.length; i++) {
                let newEditorState;
                try {
                    const parsedData = typeof item.answer_part_worktest[i].title === "string"
                        ? JSON.parse(item.answer_part_worktest[i].title)
                        : item.answer_part_worktest[i].title;
                    const contentState = convertFromRaw(parsedData);

                    newEditorState = EditorState.createWithContent(contentState); 
                } catch (error) {
                    newEditorState = EditorState.createEmpty(); 
                }

                const newRow = {
                    id: item.answer_part_worktest[i].answer_number,
                    editorState: newEditorState, 
                    score: item.answer_part_worktest[i].points,
                    ranswer: item.answer_part_worktest[i].ranswer,
                    numericValue: item.answer_part_worktest[i].type_input_int,
                    textValue: item.answer_part_worktest[i].type_input_txt,
                    optionalNumericValue: item.answer_part_worktest[i].error_rate,
                    isChecked: item.answer_part_worktest[i].right_answer,
                    file: item.answer_part_worktest[i].file,
                    selectedNumber: item.answer_part_worktest[i].sequences_selectedNumber,
                    min: item.answer_part_worktest[i].min_len,
                    max: item.answer_part_worktest[i].max_len
                };

                setRows((prevRows) => [...prevRows, newRow]); 
            }
            setCheckpoints(item.checkpoints)


        }
    }, [item?.id]);


    const [selectField, setSelectField] = useState('100');
    const [pointswrong, setPointsWrong] = useState('');
    const [pointscorrect, setPointsCorrect] = useState('');
    const [numberField, setNumberField] = useState('');
    const handleEditorChange = (index, newEditorState) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, editorState: newEditorState } : row
        );
        setRows(updatedRows);
    };

    const handleScoreChange = (index, newScore) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, score: newScore } : row
        );
        setRows(updatedRows);
    };
    const handleRightAnChange = (index, newRanswer) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, ranswer: newRanswer } : row
        );
        setRows(updatedRows);
    };

    const [checkpoints, setCheckpoints] = useState(true);

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;

        if (e.target.name === "first") {
            setCheckpoints(isChecked); 
        } else if (e.target.name === "second") {
            setCheckpoints(!isChecked); 
        }
    };
    const handleNumericChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            numericValue: value,
        };
        setRows(updatedRows);
    };

    const handleTextChange = (index, value, field) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            [field]: value,
        };
        setRows(updatedRows);
    };

    const handleOptionalNumericChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            optionalNumericValue: value,
        };
        setRows(updatedRows);
    };

    const handleCheckboxChange_row = (index, isChecked) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, isChecked } : row
        );
        setRows(updatedRows);
    };


    const handleFileChange = (index, file) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, file: file } : row
        );
        setRows(updatedRows);
    };

    const handleSelectChange = (index, newValue) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, selectedNumber: newValue } : row
        );
        setRows(updatedRows);
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!editorState || !editorState.getCurrentContent().hasText()) {
            setNotify({
                isOpen: true,
                message: "Пожалуйста, заполните текст вопроса.",
                type: "error",
            });
            return;  
        }

        const formData = new FormData();


        formData.append('checkpoints', checkpoints)
        formData.append('max_points_for_the_correct_answer', numberField);
        formData.append('type_answer', selected);
        formData.append('points_for_the_wrong_answer', pointswrong);
        formData.append('points_for_the_correct_answer', pointscorrect);
        formData.append('max_len', selectField);

        if (file) {
            formData.append('image', file); 
        }
        formData.append('body', convertEditorStateToRaw(editorState));
        formData.append('comment', convertEditorStateToRaw(editorStateComment));
        const rowsData = rows.map(row => ({
            answer_number: row.id,
            points: row.score || 0,
            ranswer: row.ranswer || 0,
            min_len: row.min || "",
            max_len: row.max || "",
            right_answer: row.isChecked || false,
            sequences_selectedNumber: row.selectedNumber || 1,
            type_input_txt: row.textValue || "",
            type_input_int: row.numericValue || null,
            error_rate: row.optionalNumericValue || null,
            title: row.editorState ? convertEditorStateToRaw(row.editorState) : null,
        }));

        formData.append('answer_part_worktest', JSON.stringify(rowsData));

        rows.forEach((row, index) => {
            if (row.file) {
                formData.append(`imageparts[${index}]`, row.file);
            }
        });

        try {
            const response = await PatchPartWorkTestAnswer(item.id, formData); 
            setNotify({
                isOpen: true,
                message: "Данные успешно отправлены!",
                type: "success",
            });

            setRows([
                { id: 1, textValue: "", score: 0, min: "", max: "", isChecked: false, file: null },
            ]);
            setNumberField('');
            setSelectField('100');
            setFile(null);
            setPointsWrong('');
            setPointsCorrect('');
            setEditorState(EditorState.createEmpty());
            ChangeRowOn(null);
            setRender(true)

        } catch (error) {
            setNotify({
                isOpen: true,
                message: "Ошибка при отправке данных!",
                type: "error",
            });
        }
    };

    const convertEditorStateToRaw = (editorState) => {
        return editorState ? JSON.stringify(convertToRaw(editorState.getCurrentContent())) : null;
    };


    return (
        <div className={styles.test_card_body} style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <>
                <div className={styles.test_card_left} style={{ width: '100%' }}>

                    <div className={styles.div_selection}>
                        {selected === 'singleSelection' && <h2>{t('surveyForm.single_selection')}</h2>}
                        {selected === 'multipleSelection' && <h2>{t('surveyForm.multiple_selection')}</h2>}
                        {selected === 'numericInput' && <h2>{t('surveyForm.numeric_input')}</h2>}
                        {selected === 'textInput' && <h2>{t('surveyForm.text_input')}</h2>}
                        {selected === 'freeTextAnswer' && <h2>{t('surveyForm.free_text_defendant')}</h2>}
                        {selected === 'sequenceOrdering' && <h2>{t('testForm.sequence_ordering')}</h2>}
                        {selected === 'slider' && <h2>{t('testForm.slider')}</h2>}
                        {selected === 'fileUpload' && <h2>{t('surveyForm.file_upload')}</h2>}
                        {selected === 'infoText' && <h2>{t('surveyForm.info_text')}</h2>}
                        {selected === 'wordsFromLetters' && <h2>{t('surveyForm.words_from_letters')}</h2>}
                        {selected === 'phrasesFromWords' && <h2>{t('surveyForm.phrases_from_words')}</h2>}
                        {selected === 'textSearch' && <h2>{t('surveyForm.text_search')}</h2>}
                        <div>
                            <button
                                onClick={() => ChangeRowOn(null)}

                                style={{

                                    padding: "10px 20px",
                                    backgroundColor: "rgb(0 37 117)",
                                    color: "#fff",
                                    border: "none",
                                    cursor: "pointer",
                                    borderRadius: "5px",
                                    marginRight: '5px',
                                }}
                            >
                                Отменить изменения
                            </button>
                            <button
                                onClick={handleSubmit}
                                style={{

                                    padding: "10px 20px",
                                    backgroundColor: "#0E7500",
                                    color: "#fff",
                                    border: "none",
                                    cursor: "pointer",
                                    borderRadius: "5px",
                                }}
                            >
                                {t('auto.surveyform_surveychangeform.k1')}
                            </button>
                        </div>

                    </div>
                    <div className={styles.test_card_left_selection}>
                        <div>
                            <label>{item.image ? "Если желаете изменить изображение вопроса:" : "Если есть изображение вопроса,"}  </label>

                            <input
                                type="file"
                                id="file-upload"
                                className={styles.file_upload_input}
                                onChange={handleFileChange_test}  
                            />
                            <label htmlFor="file-upload" className={styles.file_upload_label}>
                                {file ? file.name : 'Загрузите изображение'}
                            </label>


                        </div>

                        <div>
                            <label>{t('surveyForm.question_text')}</label>
                            <Editor
                                editorState={editorState}
                                onEditorStateChange={onEditorStateChange}
                                toolbar={{
                                    options: ["inline", "blockType", "list", "textAlign", "link", "history"],
                                    inline: { options: ["bold", "italic", "underline", "strikethrough"] },
                                }}
                                wrapperStyle={{ border: "1px solid #ccc", marginBottom: "20px" }}
                                editorStyle={{ minHeight: "200px", padding: "10px" }}
                            />


                        </div>
                        <div className={styles.point_multi_div}>
                            {(selected === 'multipleSelection' || selected === 'numericInput' || selected === 'textInput' || selected === 'slider' || selected === 'sequenceOrdering') &&

                                <>

                                    <div className={styles.point_multi_directions}>
                                        Подсчет баллов:
                                        {selected !== 'sequenceOrdering' &&
                                            <div className={styles.point_multi}>
                                                <label>{t('testForm.by_answers')}</label>
                                                <input
                                                    type="checkbox"
                                                    name="first"
                                                    checked={checkpoints}
                                                    onChange={handleCheckboxChange}
                                                />
                                            </div>
                                        }
                                        {selected !== 'sequenceOrdering' &&
                                            <div className={styles.point_multi}>
                                                <label>{t('testForm.whole_question')}</label>
                                                <input
                                                    type="checkbox"
                                                    name="second"
                                                    checked={!checkpoints} 
                                                    onChange={handleCheckboxChange}
                                                />
                                            </div>
                                        }
                                    </div>

                                    <div className={styles.point_multi_directions}>
                                        {checkpoints === false &&
                                            <>


                                                <div className={styles.point_multi}>
                                                    <span>За <span className={styles.point_color_1}>{t('testForm.correct')}</span> ответ</span>

                                                    <input
                                                        type="number"
                                                        className={styles.point_check}
                                                        value={pointscorrect}  
                                                        onChange={(e) => setPointsCorrect(e.target.value)}
                                                    />
                                                </div>
                                                <div className={styles.point_multi}>

                                                    <span>За  <span className={styles.point_color_2}>{t('testForm.wrong')}</span> ответ</span>

                                                    <input
                                                        type="number"
                                                        className={styles.point_check}
                                                        value={pointswrong}  
                                                        onChange={(e) => setPointsWrong(e.target.value)}
                                                    />
                                                </div>

                                            </>}
                                    </div>
                                </>}
                        </div>

                        <div>

                            <div>
                                {(selected === 'freeTextAnswer' || selected === 'fileUpload') &&
                                    <p style={{ fontSize: '12px' }}>  {t('auto.testform_testchangeform.k1')}</p>
                                }
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr>
                                            {(selected !== 'freeTextAnswer' && selected !== 'fileUpload' && selected !== 'infoText') &&
                                                <th className={styles.test_row_title}>№</th>}
                                            {(selected === 'singleSelection' || selected === 'multipleSelection' || selected === 'sequenceOrdering') &&
                                                <th className={styles.test_row_title}>{t('surveyForm.th_image')}</th>}
                                            {(selected === 'singleSelection' || selected === 'multipleSelection' || selected === 'sequenceOrdering') &&
                                                <th className={styles.test_row_title}>
                                                    {t('surveyForm.th_answer_text')}
                                                </th>}

                                            {(selected === 'slider') &&
                                                <th className={styles.test_row_title}>
                                                    {t('surveyForm.th_slider_name')}
                                                </th>}
                                            {(selected === 'numericInput' || selected === 'textInput') &&
                                                <th className={styles.test_row_title}>
                                                    {t('test.correct_answer')}
                                                </th>}

                                            {(selected === 'numericInput') &&
                                                <th className={styles.test_row_title}>
                                                    {t('auto.testform_testchangeform.k2')}
                                                </th>}
                                            {(selected === 'slider') && <th className={styles.test_row_title}>
                                                {t('testForm.th_correct_value')}
                                            </th>}
                                            {(((selected === 'singleSelection' || (selected === 'slider' && checkpoints === true)) || checkpoints === true) && (selected !== 'freeTextAnswer' && selected !== 'sequenceOrdering' && selected !== 'fileUpload' && selected !== 'infoText')) && <th className={styles.test_row_title}>
                                                {t('testForm.th_score')}
                                            </th>}


                                            {selected === 'freeTextAnswer' && <>
                                                <th className={styles.test_row_title}>
                                                    {t('testForm.max_score')}
                                                </th>
                                                <th className={styles.test_row_title}>
                                                    {t('testForm.max_chars')}
                                                </th>
                                            </>
                                            }
                                            {((selected === 'multipleSelection' && checkpoints === false) || selected === 'sequenceOrdering') &&

                                                <th className={styles.test_row_title}>
                                                    {t('test.correct_answer')}
                                                </th>
                                            }


                                            {(selected !== 'freeTextAnswer' && selected !== 'fileUpload' && selected !== 'infoText') &&

                                                <th className={styles.test_row_title}>
                                                    {t('common.actions')}
                                                </th>
                                            }
                                        </tr>
                                    </thead>
                                    {(selected === 'freeTextAnswer') &&

                                        <tbody>

                                            <td className={styles.test_row}>
                                                <input
                                                    type="number"
                                                    className={styles.point_check_num_text}
                                                    value={numberField}  
                                                    onChange={(e) => setNumberField(e.target.value)}  
                                                />
                                            </td>
                                            <td className={styles.test_row}>
                                                <select
                                                    className={styles.point_check_num_text}
                                                    value={selectField}  
                                                    onChange={(e) => setSelectField(e.target.value)}  
                                                >
                                                    <option value="100">100</option>
                                                    <option value="250">250</option>
                                                    <option value="500">500</option>
                                                    <option value="750">750</option>
                                                    <option value="1000">1000</option>
                                                    <option value="1500">1500</option>
                                                    <option value="2000">2000</option>
                                                    <option value="2500">2500</option>
                                                    <option value="5000">5000</option>
                                                    <option value="10000">10000</option>
                                                    <option value="15000">15000</option>
                                                </select>
                                            </td>

                                        </tbody>
                                    }
                                    {selected === 'fileUpload' &&
                                        <tbody>
                                            <td>

                                                Максимальное кол-во баллов:
                                                <input
                                                    type="number"
                                                    className={styles.point_check_num_text}
                                                    value={numberField}  
                                                    onChange={(e) => setNumberField(e.target.value)}  
                                                />
                                            </td>
                                        </tbody>
                                    }
                                    {(selected !== 'freeTextAnswer' && selected !== 'fileUpload' && selected !== 'infoText') &&
                                        <tbody>
                                            {rows.map((row, index) => (
                                                <tr key={row.id}>
                                                    {selected !== 'freeTextAnswer' &&
                                                        <td className={styles.test_row}>
                                                            {row.id}
                                                        </td>
                                                    }
                                                    {(selected === 'singleSelection' || selected === 'multipleSelection' || selected === 'sequenceOrdering') &&
                                                        <td className={styles.test_row}>

                                                            
                                                            <input
                                                                type="file"
                                                                id={`file-upload-${row.id}`}  
                                                                className={styles.file_upload_input}
                                                                onChange={(e) => handleFileChange(index, e.target.files[0])}
                                                            />
                                                            <label htmlFor={`file-upload-${row.id}`} className={styles.file_upload_label}>
                                                                {row.file ? 'Заменить изображение' : 'Загрузить изображение'}

                                                            </label>
                                                            <br></br>
                                                            {row.file ? <img src={row.file} className={styles.img_file} /> : null}

                                                        </td>
                                                    }
                                                    {(selected === 'singleSelection' || selected === 'multipleSelection' || selected === 'sequenceOrdering') &&
                                                        <td className={styles.test_row}>
                                                            <Editor
                                                                editorState={row.editorState}
                                                                onEditorStateChange={(newEditorState) =>
                                                                    handleEditorChange(index, newEditorState)
                                                                }
                                                                toolbar={{
                                                                    options: [
                                                                        "inline",
                                                                        "blockType",
                                                                        "list",
                                                                        "textAlign",
                                                                        "link",
                                                                        "history",
                                                                    ],
                                                                    inline: {
                                                                        options: ["bold", "italic", "underline", "strikethrough"],
                                                                    },

                                                                }}
                                                                wrapperStyle={{
                                                                    border: "1px solid #ccc",
                                                                }}
                                                                editorStyle={{
                                                                    minHeight: "50px",
                                                                    padding: "5px",
                                                                }}
                                                            />
                                                        </td>
                                                    }

                                                    {(selected === 'numericInput') &&
                                                        <td className={styles.test_row}>
                                                            <input
                                                                type="number"
                                                                className={styles.point_check_num_text}
                                                                value={row.numericValue || ''} 
                                                                onChange={(e) => handleNumericChange(index, e.target.value)}
                                                            />
                                                        </td>
                                                    }

                                                    {(selected === 'textInput') &&
                                                        <td className={styles.test_row}>
                                                            <input
                                                                type="text"
                                                                className={styles.point_check_num_text}
                                                                value={row.textValue || ''} 
                                                                onChange={(e) => handleTextChange(index, e.target.value, "textValue")}
                                                            />
                                                        </td>
                                                    }
                                                    {(selected === 'slider') &&
                                                        <td className={styles.test_row}>
                                                            <input
                                                                type="text"
                                                                className={styles.point_check_num_text}
                                                                value={row.textValue || ""}
                                                                onChange={(e) => handleTextChange(index, e.target.value, "textValue")}
                                                            />
                                                            <tr className={styles.point_check_under_tr}>
                                                                <td>
                                                                    <label>{t('surveyForm.min_value')}</label>
                                                                    <input
                                                                        type="number"
                                                                        className={styles.point_check_num_text}
                                                                        value={row.min || ""}
                                                                        onChange={(e) => handleTextChange(index, e.target.value, "min")}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <label>{t('surveyForm.max_value')}</label>
                                                                    <input
                                                                        type="number"
                                                                        className={styles.point_check_num_text}
                                                                        value={row.max || ""}
                                                                        onChange={(e) => handleTextChange(index, e.target.value, "max")}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </td>
                                                    }
                                                    {(selected === 'numericInput') &&
                                                        <td className={styles.test_row}>
                                                            +-<input
                                                                type="number"
                                                                className={styles.point_check}
                                                                value={row.optionalNumericValue || ''} 
                                                                onChange={(e) => handleOptionalNumericChange(index, e.target.value)}
                                                            />
                                                        </td>
                                                    }
                                                    {(((selected === 'slider'))) && <td className={styles.test_row}>
                                                        <input
                                                            type="number"
                                                            value={row.ranswer}
                                                            className={styles.point_check}
                                                            onChange={(e) =>
                                                                handleRightAnChange(index, parseInt(e.target.value, 10) || 0)
                                                            }

                                                        />
                                                    </td>
                                                    }
                                                    {(((selected === 'singleSelection') || checkpoints === true) && (selected !== 'freeTextAnswer' && selected !== 'sequenceOrdering')) && <td className={styles.test_row}>
                                                        <input
                                                            type="number"
                                                            value={row.score}
                                                            className={styles.point_check}
                                                            onChange={(e) =>
                                                                handleScoreChange(index, parseInt(e.target.value, 10) || 0)
                                                            }

                                                        />
                                                    </td>
                                                    }


                                                    {(selected === 'multipleSelection' && checkpoints === false) &&
                                                        <td className={styles.test_row}>
                                                            <input
                                                                type="checkbox"
                                                                checked={row.isChecked}  
                                                                className={styles.point_check}
                                                                onChange={(e) => handleCheckboxChange_row(index, e.target.checked)}
                                                            />
                                                        </td>
                                                    }

                                                    {(selected === 'sequenceOrdering') &&
                                                        <td className={styles.test_row}>
                                                            <select
                                                                className={styles.point_check}
                                                                value={row.selectedNumber || ''}  
                                                                onChange={(e) => handleSelectChange(index, parseInt(e.target.value, 10))}
                                                            >
                                                                {Array.from({ length: rows.length }, (_, i) => (
                                                                    <option key={i} value={i + 1}>
                                                                        {i + 1}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </td>}
                                                    {selected !== 'freeTextAnswer' && <>
                                                        <td className={styles.test_row}>
                                                            {index > 0 && (
                                                                <>
                                                                    <button
                                                                        onClick={() => moveRow(index, "up")}
                                                                        style={{
                                                                            padding: "5px 10px",
                                                                            backgroundColor: "green",
                                                                            color: "#fff",
                                                                            border: "none",
                                                                            borderRadius: "5px",
                                                                            cursor: "pointer"

                                                                        }}
                                                                    >
                                                                        ↑
                                                                    </button>
                                                                    <br></br> <br></br>
                                                                </>
                                                            )}


                                                            <button
                                                                onClick={() => removeRow(row.id)}
                                                                style={{
                                                                    padding: "5px 5px 0px 5px",
                                                                    backgroundColor: "red",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    borderRadius: "5px",
                                                                    cursor: "pointer"
                                                                }}
                                                            >
                                                                <img
                                                                    src={icon_delete}
                                                                    className={styles.img}
                                                                />
                                                            </button>

                                                            {index < rows.length - 1 && (
                                                                <> <br></br> <br></br>
                                                                    <button
                                                                        onClick={() => moveRow(index, "down")}
                                                                        style={{
                                                                            padding: "5px 10px",
                                                                            backgroundColor: "orange",
                                                                            color: "#fff",
                                                                            border: "none",
                                                                            borderRadius: "5px",
                                                                            cursor: "pointer"
                                                                        }}
                                                                    >
                                                                        ↓
                                                                    </button>
                                                                </>


                                                            )}
                                                        </td>
                                                    </>}
                                                </tr>
                                            ))}
                                        </tbody>
                                    }
                                </table>
                                {(selected !== 'freeTextAnswer' && selected !== 'fileUpload' && selected !== 'infoText') &&
                                    <button
                                        onClick={addRow}
                                        style={{
                                            marginTop: "20px",
                                            padding: "10px 20px",
                                            backgroundColor: "#007BFF",
                                            color: "#fff",
                                            border: "none",
                                            cursor: "pointer",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        {t('surveyForm.add_row')}
                                    </button>
                                }
                            </div>
                            <div style={{ marginTop: '40px' }}>
                                <label>{t('surveyForm.question_note')}</label>
                                <Editor
                                    editorState={editorStateComment}
                                    onEditorStateChange={onEditorStateChangeComment}
                                    toolbar={{
                                        options: ["inline", "blockType", "list", "textAlign", "link", "history"],
                                        inline: { options: ["bold", "italic", "underline", "strikethrough"] },
                                    }}
                                    wrapperStyle={{ border: "1px solid #ccc", marginBottom: "20px" }}
                                    editorStyle={{ minHeight: "100px", padding: "10px" }}
                                />


                            </div>
                        </div>

                    </div>

                </div>

            </>

            <Notification notify={notify} setNotify={setNotify} />
            <hr></hr>
        </div>

    );
};

export default TestChangeForm;
